import Lock from '@gravity-ui/icons/svgs/lock.svg';
import Code from '@gravity-ui/icons/svgs/code.svg';
import CircleXmark from '@gravity-ui/icons/svgs/circle-xmark.svg';
import FolderArrowDown from '@gravity-ui/icons/svgs/folder-arrow-down.svg';
import FolderOpen from '@gravity-ui/icons/svgs/folder-open.svg';
import LayoutSideContent from '@gravity-ui/icons/svgs/layout-side-content.svg';
import TrashBin from '@gravity-ui/icons/svgs/trash-bin.svg';
import Xmark from '@gravity-ui/icons/svgs/xmark.svg';

import {AbbrSql, CrownDiamond} from '@gravity-ui/icons';

export const iconNames = {
    ['lock']: Lock,
    ['code']: Code,
    ['times-circle']: CircleXmark,
    ['folder-arrow-down']: FolderArrowDown,
    ['folder-open']: FolderOpen,
    ['layout-side-content']: LayoutSideContent,
    ['sql']: AbbrSql,
    ['crowndiamond']: CrownDiamond,
    ['trash-bin']: TrashBin,
    ['xmark']: Xmark,
};
